import {
  HelpCenterEvents
} from "./chunk-AOTFDLGI.mjs";

// src/internal/components/help-center-panel/help-center-content/help-center-error-boundary.tsx
import React from "react";
import { Translation } from "@clara/locale";
import { Banner } from "@clara/ui";
import { jsx } from "react/jsx-runtime";
var ErrorBoundary = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: "", hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.message };
  }
  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
    if (this.props.trackError && this.props.eventData) {
      this.props.trackError(
        HelpCenterEvents.EXPERIENCE_HELPERSIDE_ERROR,
        this.props.eventData
      );
    }
  }
  render() {
    if (!this.state.hasError)
      return this.props.children;
    return /* @__PURE__ */ jsx(Translation, { ns: "common", children: (t) => /* @__PURE__ */ jsx(Banner, { status: "critical", children: t("helpCenter.panel.errorMessage") }) });
  }
};
var help_center_error_boundary_default = ErrorBoundary;

export {
  help_center_error_boundary_default
};
